export enum KeyboardShortcuts {
    ENTER = 'Enter',
    ESCAPE = 'Escape',
    SPACE = ' ',
    QUESTION_MARK = '?',
    SLASH = 'Slash',
    ARROW_UP = 'ArrowUp',
    ARROW_DOWN = 'ArrowDown',
    TAB = 'Tab'
}